import { Coffee } from "lucide-react";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

import { Button } from "@/components/ui/button/button";
import { getEmployeeBreaksQueryOptions } from "@/config/queries/query-options";
import { formatDuration } from "@/components/break/format";
import { isToday } from "@/utils/timezone";

import { useEmpBreaksModal } from "./use-breaks-modal";
import { EmployeeBreaksModal } from "./breaks-modal";

export const EmployeeBreaksComponent = () => {
  const { onOpenChange } = useEmpBreaksModal();

  const { empId } = useParams() as {
    empId: string;
  };

  const key = Cookies.get("key") as string;

  const { data, isPending } = useQuery(getEmployeeBreaksQueryOptions(key, empId));

  const breaks = data?.breaks ?? [];
  const today = breaks.filter((b) => isToday(b.startedAt));
  const todayTotal = today.reduce((sum, b) => sum + b.durationSeconds, 0);

  return (
    <div
      className="w-60 min-h-24 rounded-md bg-card flex flex-col justify-between gap-1 shadow-sm border p-3"
      data-testid="emp-breaks-card"
    >
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Employee Breaks</h2>

        <Coffee className="w-3 h-3" />
      </div>

      <div className="mb-2 text-xs" data-testid="emp-breaks-today">
        {isPending
          ? "Loading…"
          : today.length > 0
          ? `${today.length} ${today.length === 1 ? "break" : "breaks"} today · ${formatDuration(todayTotal)}`
          : "No breaks today"}
      </div>

      <div>
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            onOpenChange(true);
          }}
        >
          View
        </Button>
      </div>

      <EmployeeBreaksModal breaks={breaks} />
    </div>
  );
};
